import React from 'react';
import columns from './columns';
import messages from './messages';
import QuatationControls from './quotation-controls/quotation-controls';
import Breadcrumb from 'components/Common/Breadcrumb';
import List from 'features/listing/list';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Container} from 'reactstrap';
import Table from 'features/table';

const QuotationsPage = () => {
  const {t} = useTranslation();

  return (
    <div className="page-content pb-0">
      <Helmet>
        <title> {t(...messages.title())}</title>
      </Helmet>

      <Container fluid>
        <Breadcrumb
          breadcrumbItems={[
            {title: t('common.dashboard'), path: '/dashboard'},
            {title: t(...messages.title()), path: '#'},
          ]}
        />
        <Table
          url="quotations"
          otherParams={{
            delimiter: '|',
          }}
          hideSearch
          columns={columns}
          filtersComponent={QuatationControls}
          name="quotations"
        />
      </Container>
    </div>
  );
};

export default QuotationsPage;
